import React, { useContext, useEffect } from "react";
import { InformationPopUpContext } from "../../contexts/informationPopUp";
import logoImg from "../../assets/images/logo.png";
import { InfoContents, HeaderInfoContents, LogoImg, NotFoundContainer  } from './notFoundStyles'


function NotFound() {
  const { showInformationPopUp } = useContext(InformationPopUpContext);

  useEffect(() => {
    showInformationPopUp({
      title: "Página não encontrada",
      message: "Você está tentando acessar uma página inexistente",
    });
  }, [showInformationPopUp]);

  return (
    <NotFoundContainer>
      <InfoContents>
        <HeaderInfoContents>
          <LogoImg src={logoImg} alt="MrPay" />
        </HeaderInfoContents>
        <main>
          <h1>404 - Page Not Found</h1>
        </main>
      </InfoContents>
    </NotFoundContainer>
  );
}

export default NotFound;